import {SupportedForecastModelList} from './constants';
import ForecastModelListHandler from './ForecastModelListHandler';
import {ForecastModelConfig} from './types';

export const getForecastModelList = (rawModelList: ForecastModelConfig[]) => {
  const modelList = SupportedForecastModelList.flatMap((formattedModel) => {
    const matchingRows = rawModelList.filter(
      (rawModel) =>
        rawModel.forecast_model === formattedModel.serverId.forecastModel &&
        (formattedModel.serverId.meshSize === null ||
          rawModel.mesh_size === formattedModel.serverId.meshSize),
    );
    if (matchingRows.length === 0) {
      return [];
    }
    const defaultForUser = matchingRows.some((row) => row.default_for_user);
    return [{...formattedModel, defaultForUser}];
  });

  return new ForecastModelListHandler(modelList);
};
